/* Extracted from sections/custom-header.liquid on 2026-08-15.
   Was inline in every document that renders this file; now fetched once and
   cached. Deferred, so it runs after the DOM is parsed rather than at its old
   position — safer for the DOM queries inside, not riskier.
   No Liquid in here, which is why it could move at all. */

document.addEventListener('DOMContentLoaded', function () {
    if (window.innerWidth >= 900) {
      /* Mega menus open via CSS :hover/:focus-within; JS only keeps
         aria-expanded in sync and lets Escape dismiss the panel. */
      var megaItems = document.querySelectorAll('.ch__dropdown--mega');
      megaItems.forEach(function (item) {
        var trigger = item.querySelector('.ch__nav-link--mega');
        function setExpanded(state) {
          if (trigger) trigger.setAttribute('aria-expanded', state ? 'true' : 'false');
        }
        item.addEventListener('mouseenter', function () { setExpanded(true); });
        item.addEventListener('mouseleave', function () { setExpanded(false); });
        item.addEventListener('focusin', function () {
          if (!item.classList.contains('ch__dropdown--dismissed')) setExpanded(true);
        });
        item.addEventListener('focusout', function (e) {
          if (!item.contains(e.relatedTarget)) {
            item.classList.remove('ch__dropdown--dismissed');
            setExpanded(false);
          }
        });
        item.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            item.classList.add('ch__dropdown--dismissed');
            setExpanded(false);
            if (trigger) trigger.focus();
          }
        });
      });

      /* Standard dropdowns only — mega menus use pure CSS :hover */
      var navItems = document.querySelectorAll('.ch__dropdown:not(.ch__dropdown--mega)');
      navItems.forEach(function (item) {
        item.addEventListener('mouseenter', function () {
          item.setAttribute('open', '');
        });
        item.addEventListener('mouseleave', function () {
          item.removeAttribute('open');
        });
        var summary = item.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', function (e) {
            if (item.querySelector('.ch__submenu')) e.preventDefault();
          });
        }
      });
    }
  });
